import { ref, watch } from 'vue'
import { Network, type ConnectionStatus } from '@capacitor/network'
import { appInForeground } from '@/utils/appState'

const UNVERIFIED_DISCONNECT_RECHECK_MS = 1500

export const radioOffline = ref(false)
export const radioConnectionType = ref<ConnectionStatus['connectionType']>('unknown')

const reconnectCallbacks = new Set<() => void>()

let recheckTimer: ReturnType<typeof setTimeout> | null = null

function cancelPendingRecheck(): void {
  if (recheckTimer === null) return
  clearTimeout(recheckTimer)
  recheckTimer = null
}

function applyStatus(status: ConnectionStatus): void {
  const wasOffline = radioOffline.value
  radioOffline.value = !status.connected
  radioConnectionType.value = status.connectionType
  if (wasOffline && status.connected) {
    for (const callback of reconnectCallbacks) callback()
  }
}

export function readRadioStatusFromDevice(): Promise<void> {
  return Network.getStatus()
    .then(applyStatus)
    .catch(() => {})
}

function recheckOnceReplacementNetworkValidates(): void {
  cancelPendingRecheck()
  recheckTimer = setTimeout(() => {
    recheckTimer = null
    void readRadioStatusFromDevice()
  }, UNVERIFIED_DISCONNECT_RECHECK_MS)
}

function applyStatusEventTrustingOnlyConnects(status: ConnectionStatus): void {
  if (status.connected) {
    cancelPendingRecheck()
    applyStatus(status)
    return
  }
  recheckOnceReplacementNetworkValidates()
}

function rereadStatusUnmonitoredWhilePaused(inForeground: boolean): void {
  cancelPendingRecheck()
  if (inForeground) void readRadioStatusFromDevice()
}

void readRadioStatusFromDevice()

void Network.addListener('networkStatusChange', applyStatusEventTrustingOnlyConnects)

watch(appInForeground, rereadStatusUnmonitoredWhilePaused)

export function isOffline(): boolean {
  return radioOffline.value
}

export function onReconnect(callback: () => void): void {
  reconnectCallbacks.add(callback)
}
